const APPERSION = "1.0.2";
const APPHASH = "#2cb140e92519e9039ee2634827f5c2f5e0420f54";

export const getApplicationVersion = () => {
  /*eslint-disable no-useless-concat*/
  if (APPERSION === "%APPLICATION" + "_" + "VERSION%") {
    return "dev-hot-reload";
  } else {
    return APPERSION;
  }
};
export const getApplicationHash = () => {
  if (APPHASH === "%APPLICATION" + "_" + "HASH%") {
    return "#dev-hot-reload";
  } else {
    return APPHASH;
  }
};
